import { Component, OnChanges, OnInit } from '@angular/core';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { CellData } from '@ddt-web/data-service';
import { DialogConfig, DialogRef } from '@ddt-web/dialog';
import * as get from 'lodash/get';

import { ScenarioService } from '../../services';

@Component({
	selector: 'sc-simple-scenario-selection-dialog',
	templateUrl: './simple-scenario-selection-dialog.component.html',
	styleUrls: ['./simple-scenario-selection-dialog.component.scss']
})
export class SimpleScenarioSelectionDialogComponent implements OnInit, OnChanges {
	public data: any;
	public selectedScenarioKeys: Array<string> = [];
	private allScenarios: CellData[];

	constructor(
		private config: DialogConfig,
		public dialogRef: DialogRef,
		private scenarioService: ScenarioService,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) {
		this.data = config.data;
	}

	public ngOnInit(): void {
		this.updateScenariosData();
	}

	public ngOnChanges(): void {
		this.updateScenariosData();
	}

	private updateScenariosData(): void {
		if (this.data) {
			this.selectedScenarioKeys = get(this.data, 'selectedScenarios', []).map((scenario: CellData) => scenario.rawValue);
			this.allScenarios = get(this.data, 'allScenarios', []).slice(0);
		}
	}

	public deselectScenario(scenario: any): void {
		const scenarioIndex = this.selectedScenarioKeys.indexOf(scenario);
		this.selectedScenarioKeys.splice(scenarioIndex, 1);
	}

	public selectScenario(scenario: string): void {
		this.selectedScenarioKeys.push(scenario);
	}

	public isSelected(id: string): boolean {
		return this.selectedScenarioKeys.includes(id);
	}

	public saveScenarios(): void {
		this.scenarioService.saveScenarioSelection(this.dialogRef, this.selectedScenarioKeys);
	}

	public closeScenarios(): void {
		this.dialogRef.close();
	}
}
